import { createContext } from 'react';
import { IConsultantCheckoutContextData } from 'src/interfaces/context';

const ConsultantCheckoutContext = createContext<IConsultantCheckoutContextData>(
  {} as IConsultantCheckoutContextData
);

export default ConsultantCheckoutContext;
